import styled, { css } from 'styled-components';

import { Sizes } from '../../../CheckBox/enums';
import DatePicker from '../../../DatePicker';

export const StyledDatePicker = styled(DatePicker)`
  &:not(:last-child) {
    ${({ size }) => {
      switch (size) {
        case Sizes.small:
          return css`
            margin-bottom: 14px;
          `;
        case Sizes.medium:
          return css`
            margin-bottom: 24px;
          `;
        default:
          return css`
            margin-bottom: 24px;
          `;
      }
    }}
  }
`;
